import { HostedWebContentAuthSdkService, IWindowAuthenticationService } from '../hosted-web-content-auth-sdk';
import { SdkMessageTypes } from '../constants';
import { IAuthenticationService, IAuthenticationUser, ITelemetryScenario, ITelemetryService } from '../interfaces';
import { FrameContexts, IWebContentRequestMessage } from '../messages.interface';
import { getValidatedResources } from '../utils';
import { BaseAuthenticationMessageHandler } from './base-auth-message-handler';
import { WebContentSdkService } from '../web-content-sdk';
import { IWebContentContext } from '../hosted-web-content-sdk.interface';

/**
 * Responsible for handling authentication related message requests.
 */
export class AuthenticationMessageHandler extends BaseAuthenticationMessageHandler {
  constructor(
    protected appSdkHost: WebContentSdkService,
    protected authenticationService: IAuthenticationService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, authenticationService, telemetryService);
  }
  public initHandlers(): void {
    super.initHandlers();
    this.registerHandler(SdkMessageTypes.authentication.getAuthToken, this.handleGetAuthToken, {
      errorCallback: this.onGetAuthTokenError,
    });
    this.registerHandler(SdkMessageTypes.authentication.authenticate, this.handleAuthenticate, {
      errorCallback: this.onGetAuthTokenError,
    });
  }

  protected async handleAuthenticate(event: MessageEvent, url: string, width?: number, height?: number): Promise<void> {
    if (this.appDefinition) {
      const authMessageId = (event.data as IWebContentRequestMessage).id;

      const notifySuccess = async (data: string) => {
        this.appSdkHost.postResponseToApp(authMessageId, [true, data]);

        // TODO : Add telemetry loggging with scenario
      };
      const notifyFailure = async (reason: string) => {
        this.appSdkHost.postResponseToApp(authMessageId, [false, reason]);

        // TODO : Add telemetry loggging with scenario
      };
      const getUser = (): Promise<IAuthenticationUser | undefined> => {
        return this.authenticationService.getUser();
      };

      const windowAuthService: IWindowAuthenticationService = {
        getUser: getUser,
        notifySuccess: notifySuccess,
        notifyFailure: notifyFailure,
      };
      const appContext: IWebContentContext = {
        ...this.appSdkHost.getContext(),
        app: {
          ...this.appSdkHost.getContext().app,
          userClickTime: Date.now(),
        },
        page: {
          ...this.appSdkHost.getContext().page,
          frameContext: FrameContexts.authentication,
        },
      };

      new HostedWebContentAuthSdkService(
        this.appSdkHost.getHostWindow() as Window,
        { url, width, height },
        this.appDefinition,
        windowAuthService,
        appContext,
        undefined
      );
    }

    return Promise.resolve();
  }

  /**
   * Request authentication token(s) for 1st-Party hosted experiences
   */
  protected async handleGetAuthToken(_event: MessageEvent, resources: string[]): Promise<unknown> {
    let appContext = await this.appSdkHost.getAppContext();
    let validatedResources = await getValidatedResources(
      _event.origin,
      resources,
      this.appSdkHost.getHubInfo(),
      this.appDefinition,
      appContext
    );
    let authenticationToken = await this.authenticationService!.acquireToken(
      validatedResources[0]
    ); /* TODO: Move this to an api that supports fetching many tokens at once 'acquireTokens'.*/
    return [true, authenticationToken.token];
  }

  private onGetAuthTokenError(error: any, scenario: ITelemetryScenario): Promise<unknown> {
    scenario?.fail(`GetAuthToken failed ${error}`);
    return Promise.resolve([false, error]);
  }
}
